<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="teal">group</v-icon>
      项目成员
      <v-spacer/>
      <v-btn flat round color="primary" dark
             :disabled="!funcIds.includes('c_proj_memb') || project.status.identifier === 'checked'"
             @click.native.stop="
             () => {
                  editDbid = null;
                  projectId = project? project.dbid: null;
                  validRanks = rankValidItems;
                  edit = true;
                }">
        <v-icon>add</v-icon>
        新增成员
      </v-btn>
    </v-card-title>

    <v-divider color="teal" />

    <v-card-text class="pt-0">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-actions
        class="elevation-0 dense"
        no-data-text="没有数据。"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.rank}}</td>
          <td>{{ props.item.name }} {{ props.item.title ? props.item.title.name : ''}}<br/>
            {{ props.item.number }}</td>
<!--          <td>{{ props.item.number }}</td>-->
          <!--<td>{{ props.item.sex }}</td>-->
          <!--<td>{{ props.item.age }}</td>-->
<!--          <td>{{ props.item.title ? props.item.title.name : ''}}</td>-->
          <!--<td>{{ props.item.education ? props.item.education.name : '' }}</td>-->
          <td>{{ props.item.deptName }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     @click="
                         () => {
                            viewDbid = props.item.dbid; view = true;
                         }">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>查看</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!funcIds.includes('u_proj_memb') || project.status.identifier === 'checked'"
                     @click="
                      () => {
                        editDbid = props.item.dbid;
                        projectId = project? project.dbid: null;
                        validRanks = rankValidItems;
                        edit = true;
                      }">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <span>编辑</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!funcIds.includes('d_proj_memb') || project.status.identifier === 'checked'"
                     @click="
                     () => {
                        deleDbid = props.item.dbid;
                        deleMsg = `${props.item.name} / ${props.item.deptName || ''}`;
                        dele = true;
                     }">
                <v-icon color="pink">delete_forever</v-icon>
              </v-btn>
              <span>删除</span>
            </v-tooltip>
          </td>

        </template>
      </v-data-table>

    </v-card-text>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-edit
      v-model="edit"
      :dbid="editDbid"
      :project-id=projectId
      :valid-ranks="validRanks"
      v-on:ok="onEditOk"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XEdit from './Edit'
  import XView from './View'

  import XDelete from '@/components/global/Delete'

  const baseURI = '/api/proj/member';

  export default {
    components: {XEdit, XDelete, XView},

    props: {
      project: Object
    },

    data: () => ({
      uri: baseURI,
      headers: [
        {
          text: '#',
          sortable: false,
          value: 'dbid',
          width: '20'
        },
        {text: '姓名/职称/工号', value: 'name', sortable: false},
        // {text: '性别', value: 'sex', sortable: false},
        // {text: '年龄', value: 'age', sortable: false},
        // {text: '工号', value: 'number', sortable: false},
        // {text: '职称', value: 'titleId', sortable: false, width: 90},
        // {text: '学位', value: 'educId', sortable: false},
        {text: '单位', value: 'deptName', sortable: false},
        {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 60}

      ],

      items: [],

      rankItems: [
        1, 2, 3, 4, 5,
        6, 7, 8, 9, 10,
        11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
        31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
        41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
        51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
      ],

      view: false,
      viewDbid: null,

      edit: false,
      editDbid: null,
      projectId: null,
      validRanks: [],

      dele: false,
      deleDbid: null,
      deleMsg: null,

    }),

    watch: {
      project(p) {
        this.axios
            .get(`${baseURI}?projectId=${p.dbid}`)
            .then(rsp => this.items = rsp.data.items)
      }
    },

    computed: {
      ...mapGetters(['funcIds']),
      rankValidItems() {
        const invalid = this.items.map(v => v.rank);
        return this.rankItems.filter((v) => !invalid.includes(v));
      }
    },
    methods: {
      onEditOk(item) {
        //console.log("in Income onEditOK");
        if (item) {
          if (!this.editDbid) {
            this.items.unshift(item);
          } else {
            const editIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
            this.items[editIdx] = window.xutil.clone(item);
          }
          this.items = this.items.sort((a, b) => a.rank >= b.rank);
        }
      },
      onDeleOk(item) {
        if (item) {
          const deleIdx = this.items.findIndex((v, i, a) => v.dbid === item.dbid);
          this.items.splice(deleIdx, 1);
        }
      },
    }
  }
</script>
